import * as React from 'react';
import { Link, LinkProps, useLocation } from 'react-router-dom';
import { createBrowserHistory } from "history";

export const appHistory = createBrowserHistory();

const RouteLink: React.SFC<LinkProps> = (props) => {
    if (useLocation().pathname === props.to.toString()) {
        return <Link {...props} to="/refresh" />
    }
    return <Link {...props} />;
};

export default RouteLink;
